module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_2750_Inactive@1x-85b49acb168d828a30c2502735fe754c.png";